import React, { useRef, useState } from 'react';

const Knob: React.FC = () => {
  const knobRef = useRef<HTMLDivElement>(null);
  const btnList = [
    { name: 'OFF', des: '关闭', onClick: () => console.log('点击了关闭按钮') },
    { name: 'ON', des: '打开', onClick: () => console.log('点击了打开按钮') },
    { name: 'MUTE', des: '静音', onClick: () => console.log('点击了静音按钮') },
    { name: 'MAX', des: '音量MAX', onClick: () => console.log('点击了最大音量按钮') },
    { name: 'ADD', des: '音量+', onClick: () => console.log('点击了音量+按钮') },
    { name: 'REDUCE', des: '音量-', onClick: () => console.log('点击了音量-按钮') },
  ];
  const [selectCheck, setSelectCheck] = useState(0);

  const knobStyle: React.CSSProperties = {
    width: '230px',
    height: '230px',
    borderRadius: '100%',
    boxShadow: '0 0 25px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'transparent',
    position: 'relative',
  };

  const knobBackgroundStyle: React.CSSProperties = {
    width: '240px',
    height: '240px',
    overflow: 'hidden',
    borderRadius: '100%',
    boxShadow: 'inset 0 3px 10px rgba(0, 0, 0, .6),0 2px 20px rgba(255, 255, 255, 1)',
    background: 'radial-gradient(ellipse farthest-corner at center, #888888 0%, #333333 100%)',
    position: 'relative',
  };

  const knobItemStyle: React.CSSProperties = {
    width: '110px',
    height: '110px',
    clipPath: 'polygon(0% 0%,50% 0%, 100% 100%, 0% 100%)',
    position: 'absolute',
    transformOrigin: 'right bottom',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'red',
  };

  const lineStyle: React.CSSProperties = {
    width: '100%',
    height: '0',
    marginTop: '-1px',
    borderTop: '1px solid #3c3d3f',
    borderBottom: '1px solid #666769',
    transformOrigin: 'center center',
    position: 'absolute',
    top: '50%',
    left: '0%',
  };

  const btnMask: React.CSSProperties = {
    width: '66%',
    height: '66%',
    borderRadius: '100%',
    position: 'absolute',
    top: '17%',
    left: '17%',
    boxShadow: 'inset 0 2px 2px rgba(255, 255, 255, .4), 0 3px 13px rgba(0, 0, 0, .85)',
    background: 'linear-gradient(to bottom, #f2f6f5 0%, #cbd5d6 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const btnMaskShadow: React.CSSProperties = {
    width: '85%',
    height: '85%',
    borderRadius: '100%',
    background: 'linear-gradient(to bottom, #cbd5d6 0%, #f2f6f5 100%)',
  };

  return (
    <div ref={knobRef} style={knobBackgroundStyle}>
      <div style={knobStyle}>
        {btnList.map((btn, index) => (
          <div
            key={btn.name}
            style={{
              ...knobItemStyle,
              transform: `rotate(${index * 60}deg)`,
            }}
            onClick={btn.onClick}
          >
            {btn.name}
          </div>
        ))}
        <div style={lineStyle}></div>
        <div style={btnMask}>
          <div style={btnMaskShadow}></div>
        </div>
      </div>
    </div>
  );
};

export default Knob;